// extracted by mini-css-extract-plugin
export default {"config":"use_styles_config__JXF9W","settingButton":"use_styles_settingButton__FzmpI"};